import React from 'react';
import { Await, Link } from 'react-router';

import type { SurfaceNewsResponseV1 } from '~/api/v1/mall/surface-news';
import type { SurfaceResponseV1 } from '~/api/v1/mall/surface/surface-name';
import type { RecommendShopResponseV2 } from '~/api/v2/mall/recommend-shop';
import type { OfferPlatformV2 } from '~/api/v2/schemas/offer-platform';
import { AwaitErrorElement } from '~/ui/await-error-element';

import { eventCarouselStyles } from '../styles';
import { SiteEventCarousel } from './site-event-carousel';
import { SiteImportantNewsList } from './site-important-news-list';
import { SiteModalSearchKeyword } from './site-modal-search-keyword';
import { SiteRecommendShopLogo } from './site-recommend-shop-logo';

export const SiteMainContents = ({
  importantNewsPromise,
  recommendShopPromise,
  topSlideBannerPromise,
  path,
  offerPlatform,
}: {
  importantNewsPromise: Promise<SurfaceNewsResponseV1>;
  topSlideBannerPromise: Promise<SurfaceResponseV1>;
  recommendShopPromise: Promise<RecommendShopResponseV2>;
  path: string;
  offerPlatform?: OfferPlatformV2[];
}) => {
  return (
    <>
      <div className="main-container my-6">
        <SiteImportantNewsList importantNewsPromise={importantNewsPromise} />
        <SiteModalSearchKeyword path={path} offerPlatform={offerPlatform ?? []} />
      </div>
      {recommendShopPromise && (
        <React.Suspense fallback={null}>
          <Await
            resolve={recommendShopPromise}
            errorElement={<AwaitErrorElement message="recommendShop Promise failed" />}>
            {(recommendShop) =>
              recommendShop.shops &&
              recommendShop.shops.length > 0 && (
                <div className="my-6">
                  <SiteRecommendShopLogo recommendShopDetail={recommendShop.shops} />
                </div>
              )
            }
          </Await>
        </React.Suspense>
      )}
      <Link to="/guide" className="bg-brand block md:pt-[20px] md:pb-[10px]" aria-label="カブ活についてもっと知る">
        <picture>
          <source srcSet="/images/hero-banner.jpg" media="(max-width: 767px)" />
          <img
            src="/images/hero-banner-pc.png"
            className="w-full md:mx-auto md:max-w-[650px]"
            alt="カブ活についてもっと知る"
          />
        </picture>
      </Link>

      {topSlideBannerPromise && (
        <React.Suspense fallback={null}>
          <Await
            resolve={topSlideBannerPromise}
            errorElement={<AwaitErrorElement message="topSlideBanner Promise failed" />}>
            {(topSlideBanner) =>
              topSlideBanner.slot &&
              topSlideBanner.slot.length > 0 && (
                <div className="bg-grey-50 pt-8 pb-12">
                  <div className="main-container mb-3 flex items-center justify-between md:mb-6">
                    <h2 className="text-headline-xs">ピックアップ</h2>
                    <Link
                      to={import.meta.env.VITE_EVENT_LIST_ROUTE}
                      className="text-body-s text-blue-500 hover:underline"
                      aria-label="ピックアップすべて見る">
                      すべて見る
                    </Link>
                  </div>
                  <SiteEventCarousel items={topSlideBanner.slot} styles={eventCarouselStyles} />
                </div>
              )
            }
          </Await>
        </React.Suspense>
      )}
    </>
  );
};
